{
  "salon-visited-page": {
    "buttons": {
      "book-appointment": "BOOK APPOINTMENT"
    },
    "text": {
      "no-visited-salon": "No visited salon can be found",
      "promotional-message": "Promotional message",
      "visited-salon": "Visited salons"
    },
    "meta": {
      "title": "Visited salons",
      "description": "List of salons visited"
    }
  }
}
